module.exports = __webpack_public_path__ + "src/assets/games/15/136.jpg";